import { useIntl } from 'react-intl';
import DefaultLayout from 'admin/components/DefaultLayout';
import FarmDeliveries from 'admin/components/FarmDeliveries';
import { Tabs } from 'ui';

export const FarmDeliveriesPage = () => {
  const intl = useIntl();

  const items = [
    {
      key: 'deliveries',
      label: intl.formatMessage({ id: 'navigation.deliveries' }),
      children: <FarmDeliveries />,
    },
  ];

  return (
    <DefaultLayout.PageLayout
      breadcrumbs={[
        {
          title: intl.formatMessage({ id: 'navigation.beginning' }),
        },
        {
          title: intl.formatMessage({ id: 'navigation.deliveries' }),
        },
      ]}
    >
      <DefaultLayout.PageContent>
        <Tabs items={items} />
      </DefaultLayout.PageContent>
    </DefaultLayout.PageLayout>
  );
};
